import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable';
const ProductSubGroup = Loadable(lazy(() => import("./ProductSubGroup")));

const ProductSubGroupRoutes = [
    {
        path: '/productsubgroup',
        element: <ProductSubGroup />,
    },
]

export default ProductSubGroupRoutes
